import { isLocal, isTestnet } from './envs';


export const MINIMUM_REQUIREMENTS_INFO = 'You need at least Base Gun, Base Ammo and 1x level-0 character to start playing and earn. Or a closed Starter/Advanced pack.';

export const chainId = (isTestnet && !isLocal) ? 'ssc-testnet-hive' : 'ssc-mainnet-hive';
